import usePageContext from '@rover/react-lib/src/context/usePageContext';

import useIsBHUser from './useIsBHUser';

const useIsBrightHorizonsNavigation = (): boolean => {
  const isBHUser = useIsBHUser();
  const { pageName, navbarVariant } = usePageContext();

  return isBHUser || pageName === 'ssr-bh-hub' || navbarVariant === 'bright-horizons';
};

export default useIsBrightHorizonsNavigation;
